var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2501px",
    height: "1271px",
    viewBox: "0 0 2501 1271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M585.969132,190.29861 L585.969132,213.929213 L582.051592,213.929213 L582.051592,285.750785 L576.828205,285.750785 L576.828205,496.302037 L596.415906,496.302037 L596.415906,511.972198 L661.272963,511.972198 L661.272963,620.918124 L257.205666,620.918124 L257.205666,261.6849 L326.415545,261.6849 L326.415545,190.29861 L585.969132,190.29861 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 1,
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426",
    points: "820.088306 206.902016 820.088306 271.759073 815.735484 271.759073 815.735484 289.170363 800.500605 289.170363 800.500605 492.88246 815.735484 492.88246 815.735484 576.891935 663.821976 576.891935 663.821976 509.423185 598.964919 509.423185 598.964919 493.753024 579.377218 493.753024 579.377218 288.299798 584.600605 288.299798 584.600605 216.478226 588.518145 216.478226 588.518145 206.902016"
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1255.43325,209.451029 L1255.43325,215.109698 L1259.35079,215.109698 L1259.35079,266.037723 L1275.02095,266.037723 L1275.02095,286.62135 L1268.05643,286.62135 L1268.05643,616.565302 L968.456876,616.565302 L968.456876,497.607884 L1020.25546,497.607884 L1020.25546,209.451029 L1255.43325,209.451029 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M1502.67357,191.169174 L1502.67357,496.302037 L1520.08486,496.302037 L1520.08486,559.543326 L1488.74454,559.543326 L1488.74454,616.565302 L1273.15446,616.565302 L1273.15446,291.719376 L1280.11897,291.719376 L1280.11897,260.939697 L1264.44881,260.939697 L1264.44881,210.011673 L1260.53127,210.011673 L1260.53127,204.353003 L1249.64921,204.353003 L1249.64921,191.169174 L1502.67357,191.169174 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1740.33768,191.169174 L1740.33768,260.504415 L1736.42014,260.504415 L1736.42014,286.186068 L1721.18526,286.186068 L1721.18526,495.866755 L1736.42014,495.866755 L1736.42014,559.978608 L1525.18288,559.978608 L1525.18288,491.204011 L1507.77159,491.204011 L1507.77159,191.169174 L1740.33768,191.169174 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M2202.17216,191.169174 L2202.17216,733.220947 L1985.27623,733.220947 L1985.27623,724.515302 L1892.12583,724.515302 L1892.12583,631.800181 L1815.95143,631.800181 L1815.95143,622.659253 L1786.35224,622.659253 L1786.35224,619.486916 L1806.37522,619.486916 L1806.37522,549.841755 L1827.70405,549.841755 L1827.70405,497.607884 L1946.53611,497.607884 L1946.53611,262.245544 L1942.61857,262.245544 L1942.61857,191.169174 L2202.17216,191.169174 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1746.43163,619.922198 L1746.43163,627.757279 L1810.85341,627.757279 L1810.85341,636.898206 L1887.0278,636.898206 L1887.0278,729.613327 L1980.1782,729.613327 L1980.1782,738.318973 L2202.17216,738.318973 L2202.17216,1035.74212 L1711.04841,1035.74212 L1711.04841,944.642763 L1731.94196,944.642763 L1731.94196,619.922198 L1746.43163,619.922198 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M1726.84393,619.94602 L1726.84393,939.544737 L1705.95038,939.544737 L1705.95038,982.637681 L1497.7601,982.637681 L1497.7601,727.872198 L1544.77059,727.872198 L1544.77059,621.639726 L1726.84393,619.94602 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1539.67256,621.663327 L1539.67256,722.774173 L1492.66208,722.774173 L1492.66208,982.637681 L1275.33087,982.637681 L1275.33087,933.450785 L1262.2724,933.450785 L1262.2724,621.663327 L1539.67256,621.663327 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1257.17437,621.663327 L1257.17437,938.548811 L1270.23284,938.548811 L1270.23284,987.735706 L1278.5032,987.735706 L1278.5032,1052.71812 L1019.82018,1052.71812 L1019.82018,1047.36938 L1031.5728,1047.36938 L1031.5728,748.020544 L1024.173,748.020544 L1024.173,735.83264 L968.456876,735.83264 L968.456876,621.663327 L1257.17437,621.663327 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M963.35885,671.720787 L963.35885,740.930666 L1019.07498,740.930666 L1019.07498,753.118569 L1026.47478,753.118569 L1026.47478,1042.27135 L1014.72216,1042.27135 L1014.72216,1052.71812 L804.790747,1052.71812 L804.790747,671.720787 L963.35885,671.720787 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M799.692721,671.720787 L799.692721,1052.71812 L582.361513,1052.71812 L582.361513,751.812723 L601.513932,751.812723 L601.513932,727.872198 L657.230061,727.872198 L657.230061,671.720787 L799.692721,671.720787 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M661.272963,626.01615 L661.272963,666.622761 L652.132035,666.622761 L652.132035,722.774173 L596.415906,722.774173 L596.415906,746.714697 L577.263487,746.714697 L577.263487,1052.71812 L326.850827,1052.71812 L326.850827,983.072963 L257.205666,983.072963 L257.205666,626.01615 L661.272963,626.01615 Z",
    stroke: "#FFD426",
    strokeWidth: 5.09802581,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor11);
export default __webpack_public_path__ + "static/media/select-floor-11.72d3c9fd.svg";
export { ForwardRef as ReactComponent };